// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3wldU","containerItemsCenter":"Skeleton_containerItemsCenter__1vubN"};